import React from "react";
import './TitleView.scss'

const TitleView = ({ title, children,description=""}) => {
    return (
        <>
            <div className="TitleView">
                <div className="title">{title}</div>
                <div className="TitleView">{children}</div>
            </div>
            <div className="border"></div>
        </>
    )
}
export default TitleView